module.exports = __webpack_public_path__ + "img/sq.a2de46e5.svg";